module.exports = {"attributes":{"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M10.6204 8.69629C10.8711 8.69629 11.0743 8.8997 11.0745 9.15039C11.0745 9.40125 10.8712 9.60547 10.6204 9.60547H0.454346C0.20354 9.6054 0.000244141 9.40121 0.000244141 9.15039C0.000440476 8.89974 0.203662 8.69636 0.454346 8.69629H10.6204ZM10.6204 4.54395C10.8712 4.54395 11.0745 4.74718 11.0745 4.99805C11.0743 5.2488 10.8711 5.45215 10.6204 5.45215H0.454346C0.203622 5.45208 0.000375898 5.24876 0.000244141 4.99805C0.000244141 4.74723 0.203541 4.54401 0.454346 4.54395H10.6204ZM10.6204 0.390625C10.8712 0.390625 11.0744 0.593922 11.0745 0.844727C11.0745 1.09559 10.8712 1.29883 10.6204 1.29883H0.454346C0.203541 1.29876 0.000244141 1.09555 0.000244141 0.844727C0.000311747 0.593963 0.203582 0.390693 0.454346 0.390625H10.6204Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
